import { DialogContent, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PickerContent = styled(DialogContent) `
  position: relative;
  padding: ${themeGet('spacing.2xl')};
  border-top: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
